/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/const/HttpHeaders.ts
 * @create:      2022-04-19 13:30:53.811
 * @modify:      2025-07-11 20:47:10.776
 * @version:     6.0.0
 * @times:       15
 * @lines:       151
 * @copyright:   Copyright © 2022-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     [license]
 * @see:         https://en.wikipedia.org/wiki/List_of_HTTP_header_fields
 ********************************************************************/

// Standard request fields

export const HttpStandardRequestHeader_AIm = "A-IM";
export const HttpStandardRequestHeader_Accept = "Accept";
export const HttpStandardRequestHeader_AcceptCharset = "Accept-Charset";
export const HttpStandardRequestHeader_AcceptDatetime = "Accept-Datetime";
export const HttpStandardRequestHeader_AcceptEncoding = "Accept-Encoding";
export const HttpStandardRequestHeader_AcceptLanguage = "Accept-Language";
export const HttpStandardRequestHeader_AccessControlRequestMethod = "Access-Control-Request-Method";
export const HttpStandardRequestHeader_AccessControlRequestHeaders = "Access-Control-Request-Headers";
export const HttpStandardRequestHeader_Authorization = "Authorization";
export const HttpStandardRequestHeader_CacheControl = "Cache-Control";
export const HttpStandardRequestHeader_Connection = "Connection";
export const HttpStandardRequestHeader_ContentEncoding = "Content-Encoding";
export const HttpStandardRequestHeader_ContentLength = "Content-Length";
export const HttpStandardRequestHeader_ContentMd5 = "Content-MD5";
export const HttpStandardRequestHeader_ContentType = "Content-Type";
export const HttpStandardRequestHeader_Cookie = "Cookie";
export const HttpStandardRequestHeader_Date = "Date";
export const HttpStandardRequestHeader_Expect = "Expect";
export const HttpStandardRequestHeader_Forwarded = "Forwarded";
export const HttpStandardRequestHeader_From = "From";
export const HttpStandardRequestHeader_Host = "Host";
export const HttpStandardRequestHeader_Http2Settings = "HTTP2-Settings";
export const HttpStandardRequestHeader_IfMatch = "If-Match";
export const HttpStandardRequestHeader_IfModifiedSince = "If-Modified-Since";
export const HttpStandardRequestHeader_IfNoneMatch = "If-None-Match";
export const HttpStandardRequestHeader_IfRange = "If-Range";
export const HttpStandardRequestHeader_IfUnmodifiedSince = "If-Unmodified-Since";
export const HttpStandardRequestHeader_MaxForwards = "Max-Forwards";
export const HttpStandardRequestHeader_Origin = "Origin";
export const HttpStandardRequestHeader_Pragma = "Pragma";
export const HttpStandardRequestHeader_Prefer = "Prefer";
export const HttpStandardRequestHeader_ProxyAuthorization = "Proxy-Authorization";
export const HttpStandardRequestHeader_Range = "Range";
export const HttpStandardRequestHeader_Referer = "Referer";
export const HttpStandardRequestHeader_Te = "TE";
export const HttpStandardRequestHeader_Trailer = "Trailer";
export const HttpStandardRequestHeader_TransferEncoding = "Transfer-Encoding";
export const HttpStandardRequestHeader_UserAgent = "User-Agent";
export const HttpStandardRequestHeader_Upgrade = "Upgrade";
export const HttpStandardRequestHeader_Via = "Via";
export const HttpStandardRequestHeader_Warning = "Warning";

// Common non-standard request fields

export const HttpRequestHeader_UpgradeInsecureRequests = "Upgrade-Insecure-Requests";
export const HttpRequestHeader_XRequestedWith = "X-Requested-With";
export const HttpRequestHeader_Dnt = "DNT";
export const HttpRequestHeader_XForwardedFor = "X-Forwarded-For";
export const HttpRequestHeader_XForwardedHost = "X-Forwarded-Host";
export const HttpRequestHeader_XForwardedProto = "X-Forwarded-Proto";
export const HttpRequestHeader_FrontEndHttps = "Front-End-Https";
export const HttpRequestHeader_XHttpMethodOverride = "X-Http-Method-Override";
export const HttpRequestHeader_XAttDeviceId = "X-ATT-DeviceId";
export const HttpRequestHeader_XWapProfile = "X-Wap-Profile";
export const HttpRequestHeader_ProxyConnection = "Proxy-Connection";
export const HttpRequestHeader_XUidh = "X-UIDH";
export const HttpRequestHeader_XCsrfToken = "X-Csrf-Token";
export const HttpRequestHeader_XRequestId = "X-Request-ID";
export const HttpRequestHeader_XCorrelationId = "X-Correlation-ID";
export const HttpRequestHeader_SaveData = "Save-Data";

// Standard response fields

export const HttpStandardResponseHeader_AcceptCh = "Accept-CH";
export const HttpStandardResponseHeader_AccessControlAllowOrigin = "Access-Control-Allow-Origin";
export const HttpStandardResponseHeader_AccessControlAllowCredentials = "Access-Control-Allow-Credentials";
export const HttpStandardResponseHeader_AccessControlExposeHeaders = "Access-Control-Expose-Headers";
export const HttpStandardResponseHeader_AccessControlMaxAge = "Access-Control-Max-Age";
export const HttpStandardResponseHeader_AccessControlAllowMethods = "Access-Control-Allow-Methods";
export const HttpStandardResponseHeader_AccessControlAllowHeaders = "Access-Control-Allow-Headers";
export const HttpStandardResponseHeader_AcceptPatch = "Accept-Patch";
export const HttpStandardResponseHeader_AcceptRanges = "Accept-Ranges";
export const HttpStandardResponseHeader_Age = "Age";
export const HttpStandardResponseHeader_Allow = "Allow";
export const HttpStandardResponseHeader_AltSvc = "Alt-Svc";
export const HttpStandardResponseHeader_CacheControl = "Cache-Control";
export const HttpStandardResponseHeader_Connection = "Connection";
export const HttpStandardResponseHeader_ContentDisposition = "Content-Disposition";
export const HttpStandardResponseHeader_ContentEncoding = "Content-Encoding";
export const HttpStandardResponseHeader_ContentLanguage = "Content-Language";
export const HttpStandardResponseHeader_ContentLength = "Content-Length";
export const HttpStandardResponseHeader_ContentLocation = "Content-Location";
export const HttpStandardResponseHeader_ContentMd5 = "Content-MD5";
export const HttpStandardResponseHeader_ContentRange = "Content-Range";
export const HttpStandardResponseHeader_ContentType = "Content-Type";
export const HttpStandardResponseHeader_Date = "Date";
export const HttpStandardResponseHeader_DeltaBase = "Delta-Base";
export const HttpStandardResponseHeader_ETag = "ETag";
export const HttpStandardResponseHeader_Expires = "Expires";
export const HttpStandardResponseHeader_Im = "IM";
export const HttpStandardResponseHeader_LastModified = "Last-Modified";
export const HttpStandardResponseHeader_Link = "Link";
export const HttpStandardResponseHeader_Location = "Location";
export const HttpStandardResponseHeader_P3P = "P3P";
export const HttpStandardResponseHeader_Pragma = "Pragma";
export const HttpStandardResponseHeader_PreferenceApplied = "Preference-Applied";
export const HttpStandardResponseHeader_ProxyAuthenticate = "Proxy-Authenticate";
export const HttpStandardResponseHeader_PublicKeyPins = "Public-Key-Pins";
export const HttpStandardResponseHeader_RetryAfter = "Retry-After";
export const HttpStandardResponseHeader_Server = "Server";
export const HttpStandardResponseHeader_SetCookie = "Set-Cookie";
export const HttpStandardResponseHeader_StrictTransportSecurity = "Strict-Transport-Security";
export const HttpStandardResponseHeader_Trailer = "Trailer";
export const HttpStandardResponseHeader_TransferEncoding = "Transfer-Encoding";
export const HttpStandardResponseHeader_Tk = "Tk";
export const HttpStandardResponseHeader_Upgrade = "Upgrade";
export const HttpStandardResponseHeader_Vary = "Vary";
export const HttpStandardResponseHeader_Via = "Via";
export const HttpStandardResponseHeader_Warning = "Warning";
export const HttpStandardResponseHeader_WwwAuthenticate = "WWW-Authenticate";
export const HttpStandardResponseHeader_XFrameOptions = "X-Frame-Options";

// Common non-standard response fields

export const HttpResponseHeader_ContentSecurityPolicy = "Content-Security-Policy";
export const HttpResponseHeader_XContentSecurityPolicy = "X-Content-Security-Policy";
export const HttpResponseHeader_XWebKitCsp = "X-WebKit-CSP";
export const HttpResponseHeader_ExpectCt = "Expect-CT";
export const HttpResponseHeader_Nel = "NEL";
export const HttpResponseHeader_PermissionsPolicy = "Permissions-Policy";
export const HttpResponseHeader_Refresh = "Refresh";
export const HttpResponseHeader_ReportTo = "Report-To";
export const HttpResponseHeader_Status = "Status";
export const HttpResponseHeader_TimingAllowOrigin = "Timing-Allow-Origin";
export const HttpResponseHeader_XContentDuration = "X-Content-Duration";
export const HttpResponseHeader_XContentTypeOptions = "X-Content-Type-Options";
export const HttpResponseHeader_XPoweredBy = "X-Powered-By";
export const HttpResponseHeader_XRedirectBy = "X-Redirect-By";
export const HttpResponseHeader_XRequestId = "X-Request-ID";
export const HttpResponseHeader_XCorrelationId = "X-Correlation-ID";
export const HttpResponseHeader_XUaCompatible = "X-UA-Compatible";
export const HttpResponseHeader_XXssProtection = "X-XSS-Protection";
